/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ajoute une valeur à l'indice. Si une valeur existe déjà à cette date de début, elle est remplacée plutôt que dédoublée : c'est ainsi qu'on corrige une saisie, sans passer par une suppression.
 * @export
 * @interface AjouterValeurIndiceCommand
 */
export interface AjouterValeurIndiceCommand {
    /**
     * Date calendaire "yyyy-MM-dd". L'heure est ignorée par le back, aucune conversion de fuseau n'est appliquée.
     * @type {string}
     * @memberof AjouterValeurIndiceCommand
     */
    startDate: string;
    /**
     * Valeur de l'indice, jusqu'à trois décimales.
     * @type {number}
     * @memberof AjouterValeurIndiceCommand
     */
    value: number;
}

/**
 * Check if a given object implements the AjouterValeurIndiceCommand interface.
 */
export function instanceOfAjouterValeurIndiceCommand(value: object): value is AjouterValeurIndiceCommand {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AjouterValeurIndiceCommandFromJSON(json: any): AjouterValeurIndiceCommand {
    return AjouterValeurIndiceCommandFromJSONTyped(json, false);
}

export function AjouterValeurIndiceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AjouterValeurIndiceCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'],
        'value': json['value'],
    };
}

export function AjouterValeurIndiceCommandToJSON(json: any): AjouterValeurIndiceCommand {
    return AjouterValeurIndiceCommandToJSONTyped(json, false);
}

export function AjouterValeurIndiceCommandToJSONTyped(value?: AjouterValeurIndiceCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'value': value['value'],
    };
}

